import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntakeDocViewComponent } from './intake-doc-view.component';
import { IntakeDocFileComponent } from './intake-doc-file.component';
import { IntakeDocMetadataInfoComponent } from './intake-doc-metadata-info.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { PdfPreviewDialogModule } from '@ee/common/pdf-preview-dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { OverlayModule } from '@angular/cdk/overlay';
import { TippyDirective } from '@ngneat/helipopper';
import { EePipesModule } from '@ee/common/pipes';

@NgModule({
  imports: [
    CommonModule,
    MatSnackBarModule,
    MatDialogModule,
    PdfPreviewDialogModule,
    OverlayModule,
    MatButtonModule,
    MatIconModule,
    TippyDirective,
    EePipesModule
  ],
  declarations: [
    IntakeDocViewComponent,
    IntakeDocFileComponent,
    IntakeDocMetadataInfoComponent
  ],
  exports: [
    IntakeDocViewComponent,
    IntakeDocFileComponent,
    IntakeDocMetadataInfoComponent
  ]
})
export class IntakeDocViewModule {}

